import { GlobalContext } from "components/GlobalContext";
import { IAnswerCount, IHRAOverviewReportResult } from "models/reports/IHRAOverviewReport";
import moment from "moment";
import { useContext, useRef, useState, useEffect } from "react";
import { Button, Row, Col, Form, Card } from "react-bootstrap";
import ReportService from "services/ReportService";
import './styles/OpportunityReport.scss';

const HRAOverviewReport = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    const [startDate, setStartDate] = useState<string>("1/1/2020");
    const [endDate, setEndDate] = useState<string>("1/1/2025");
    const [reportData, setReportData] = useState<IHRAOverviewReportResult>();
    const [forceRefresh, setForceRefresh] = useState<Date>(new Date());

    globalContextRef.current = globalContext;
    useEffect(() => {
        if (startDate && endDate) {
            (async () => {
                globalContextRef.current.setLoading(true);
                const accessToken = await globalContextRef.current.getAccessTokenAsync();
                const result = await ReportService.HRAOverviewAsync(accessToken, startDate, endDate);

                if (result) {
                    setReportData(result);
                }

                globalContextRef.current.setLoading(false);
            })();
        }
    }, [forceRefresh]);

    const getUniqueCategoryTitles = () => {
        if (reportData) {
            return (
                reportData
                    .answerCounts
                    .map(q => q.categoryTitle)
                    .filter((value, index, self) => self.indexOf(value) === index)
            );
        }
    };

    const getUniqueQuestions = (answerCounts: IAnswerCount[]) => {
        if (reportData) {
            return (
                answerCounts
                    .map(q => q.question)
                    .filter((value, index, self) => self.indexOf(value) === index)
            );
        }
    };

    const getAnswerPercentage = (question: string, index: number) => {
        if (reportData) {
            const answerCount = reportData.answerCounts.filter(q => q.question === question)[index];
            const totalAnswerCount = reportData.answerCounts.filter(q => q.question === question).map(q => q.count).reduce((a, b) => a + b, 0);
            return ((answerCount.count / totalAnswerCount) * 100).toFixed(2) + "%";
        }
    };

    return (
        <>
            <Row>
                <Col>
                    <Card className="mb-3">
                        <Card.Body>
                            <Form>
                                <Row>
                                    <Col className="align-items-end">
                                        <Form.Group>
                                            <Form.Label>Start Date</Form.Label>
                                            {
                                                <Form.Control
                                                    type="date"
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setStartDate(e.target.value)}
                                                    value={startDate ? moment(startDate).format('yyyy-MM-DD') : undefined}
                                                />
                                            }
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>End Date</Form.Label>
                                            {
                                                <Form.Control
                                                    type="date"
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEndDate(e.target.value)}
                                                    value={endDate ? moment(endDate).format('yyyy-MM-DD') : undefined}
                                                />
                                            }
                                        </Form.Group>
                                    </Col >
                                    <Col style={{ "alignSelf": "flex-end" }}>
                                        <Button
                                            variant="primary"
                                            className="mt-2"
                                            style={{ width: "100%" }}
                                            onClick={() => setForceRefresh(new Date())}>
                                            Update
                                        </Button>
                                    </Col>
                                </Row >
                            </Form>
                        </Card.Body>
                    </Card >
                </Col>
            </Row>
            <Row className="HRAOverviewReportResults">
                <Col>
                    {
                        !reportData &&
                        <Row><Col>Please choose a start and end date</Col></Row>
                    }
                    {
                        reportData &&
                        <div className="answer-view">
                            <div>
                                <div className="ts-container">
                                    <div className="ts-custom-card mb-05 mb-lg-06">
                                        <div className="ts-custom-card__body p-0">
                                            <strong><i>Showing overview for {reportData.hraCount} submissions</i></strong>
                                            <div className="ts-factor-list list-unstyled mb-0">
                                                {
                                                    (getUniqueCategoryTitles() || [])
                                                        .map(
                                                            (title, index) =>
                                                                <Row className="align-items-start">

                                                                    <li className={`ts-factor-list-li ${(index % 1 === 0 ? " ts-factor-list-li--active" : "")}`}>
                                                                        <h2 className="ts-text-900 ts-fs-24 fw-semibold mt-3">
                                                                            {title}
                                                                        </h2>

                                                                        <Row className="ts-factor-sublist list-unstyled mb-0">
                                                                            {
                                                                                (getUniqueQuestions(
                                                                                    reportData
                                                                                        .answerCounts
                                                                                        .filter(q => q.categoryTitle === title)
                                                                                ) || [])
                                                                                    .map(
                                                                                        (question, index) =>
                                                                                            <Col className="align-items-start ts-factor-sublist__item ts-factor-sublist__item--active">
                                                                                                <div className="ts-factor-sublist__item--left">
                                                                                                    <h3 className="ts-fs-36 ts-text-gray-400 mb-0">Q{index + 1}</h3>
                                                                                                </div>
                                                                                                <div>
                                                                                                    <p className="ts-text-gray-900 fw-semibold ts-fs-14 mb-1">
                                                                                                        {question}
                                                                                                    </p>
                                                                                                    <p className="ts-text-gray-500 ts-fs-14 mb-1">
                                                                                                    </p>
                                                                                                    {
                                                                                                        reportData.answerCounts.filter(q => q.question === question).sort((a, b) => b.answerIndex - a.answerIndex).map(
                                                                                                            (answerCount, index) =>
                                                                                                                <span data-total={answerCount.count}>
                                                                                                                    <span style={{ "color": "red", "fontWeight": "bold", "minWidth": "60px", "display": "inline-block" }}>{getAnswerPercentage(question, index)}</span> {answerCount.answer}<br />
                                                                                                                </span>
                                                                                                        )
                                                                                                    }
                                                                                                </div>
                                                                                            </Col>
                                                                                    )
                                                                            }
                                                                        </Row>
                                                                    </li>
                                                                </Row>
                                                        )
                                                }
                                            </div >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </Col >
            </Row >
        </>
    );
}

export default HRAOverviewReport;
